"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCalendar = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCalendar = styled_components_1.default.div `
  .react-datepicker__aria-live {
    display: none;
  }

  .react-datepicker-wrapper {
    position: relative;
    max-width: 220px;
  }
  .react-datepicker {
    border-radius: 4px;
    border: none;
    background: ${({ theme }) => theme.white};
    box-shadow: 0px 0px 4px rgba(191, 191, 191, 0.5);
  }

  .react-datepicker__month-container {
    position: relative;
  }

  .react-datepicker__day-names {
    display: flex;
    justify-content: space-around;
    margin-top: 10px;
    color: ${({ theme }) => theme.neutral.light};
    text-transform: uppercase;
  }

  .react-datepicker__header {
    position: initial;
    background: white;
    border: none;
    padding: 15px;
  }

  .react-datepicker__day {
    color: ${({ theme }) => theme.neutral.main};
    font-size: 14px;
    transition: all 0.4s ease-in-out;
    &:hover {
      border-radius: 50px;
      background: ${({ theme }) => theme.primary.light};
    }

    &:focus-visible {
      outline-color: ${({ theme }) => theme.neutral.main};
    }

    &.react-datepicker__day--outside-month,
    &.react-datepicker__day--disabled {
      color: ${({ theme }) => theme.neutral.light};

      &:hover {
        background: transparent;
      }
    }

    &.react-datepicker__day--today {
      background: transparent;
      font-weight: bold;
      color: ${({ theme }) => theme.neutral.main};
    }
  }

  .react-datepicker__day-name {
    color: ${({ theme }) => theme.neutral.light};
    font-size: 12px;
  }

  .react-datepicker__day--keyboard-selected {
    background: none;
    color: ${({ theme }) => theme.neutral.main};
  }

  .react-datepicker__day.react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day.react-datepicker__day--today.react-datepicker__day--in-selecting-range {
    background: ${({ theme }) => theme.primary.light};
    border-radius: 100%;
    color: ${({ theme }) => theme.neutral.main};
    &:hover {
      background: ${({ theme }) => theme.primary.light};
    }
  }
  /* .react-datepicker__day.react-datepicker__day--selected, */
  .react-datepicker__day.react-datepicker__day--selected:not(.react-datepicker__day--today),
  .react-datepicker__day.react-datepicker__day--selected,
  .react-datepicker__day--range-end,
  .react-datepicker__day--range-start,
  .react-datepicker__day--in-range {
    color: white;
    border-radius: 100%;
  }

  /* .react-datepicker__day.react-datepicker__day--selected, */
  .react-datepicker__day.react-datepicker__day--selected:not(.react-datepicker__day--today),
  .react-datepicker__day.react-datepicker__day--selected,
  .react-datepicker__day--in-range.react-datepicker__day--range-end,
  .react-datepicker__day--in-range.react-datepicker__day--range-start {
    background: ${({ theme }) => theme.primary.main};
    color: white;
  }

  .react-datepicker__month {
    margin: 0;
    padding: 0 15px 15px;
  }

  .react-datepicker__current-month {
    text-align: left;
    margin-left: 20px;
  }
  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker-popper[data-placement^="bottom"] {
    padding-top: 12px;
  }
`;
